<template>
    <div v-loading="loading" v-if="detail" class="detail">
        <div class="content">
            <div class="content-title">
                <div class="title-line"></div>
                <div class="title">方案详情</div>
            </div>
            <div class="flex detail-content justify-between ">
                <div class="flex">
                    <img class="detail-img" :src="detail.coverUrl" />
                    <div class="flex fd justify-between" style="margin-left: 32px;">
                        <div>
                            <div class="title">{{ detail.title }}</div>
                            <div class="finish-time" style="margin-top: 16px;">完成时间：{{ detail.finishDate }}</div>
                            <div class="finish-time" style="margin-top: 12px;">产业方向：{{ detail.industrialDirection }}</div>
                            <div class="finish-time" style="margin-top: 12px;">所在区域：{{ detail.area }}</div>
                            <div class="d-data">
                                <div class="eye">
                                    <img src="../../../../assets/icon/icon-eye.png" />
                                    <span>{{ detail.browseNum }} 次查阅</span>
                                </div>
                                <div class="download">
                                    <img src="../../../../assets/icon/icon-download-blue.png" />
                                    <span>{{ detail.downNum }} 人下载</span>
                                </div>
                            </div>
                        </div>
                        <div class="money">
                            <span class="unit">￥</span>
                            <span class="num">{{ detail.webPrice }}</span>
                        </div>
                        <div class="btn">
                            <el-button @click="readPdf(detail.id)" plain v-if="detail.isBuy == 1 || detail.webPrice == 0"
                                style="border:1px solid #306EFF;margin-left: 6px;">
                                <div class="btn-type">
                                    <img src="../../../../assets/icon/icon-read.png" />
                                    <span>点击阅读</span>
                                </div>
                            </el-button>
                            <el-button v-else @click="toTrial(detail.id)" plain
                                style="border:1px solid #306EFF;margin-left: 6px;">
                                <div class="btn-type">
                                    <img src="../../../../assets/icon/icon-read.png" />
                                    <span>点击试读</span>
                                </div>
                            </el-button>
                            <a v-if="detail.isBuy == 1 || detail.webPrice == 0"
                                :href="basUrl + '/report_hall/case_report?id=' + detail.id + '&userId=' + userId">
                                <el-button style="background-color: #306EFF;margin-left: 24px;" type="primary">
                                    <div class="btn-type">
                                        <img src="../../../../assets/icon/icon-download-white.png" />
                                        <span>点击下载</span>
                                    </div>
                                </el-button>
                            </a>
                            <el-button @click="setPayment" v-else style="background-color: #306EFF;margin-left: 24px;"
                                type="primary">
                                <div class="btn-type">
                                    <img src="../../../../assets/icon/icon-download-white.png" />
                                    <span>立即购买</span>
                                </div>
                            </el-button>


                        </div>
                    </div>
                </div>
                <div>
                    <a @click="setCollect(1)" v-if="detail.isCollect == 0" style="cursor:pointer">
                        <img src="../../../../assets/images/collect.png" />
                    </a>
                    <a @click="setCollect(2)" v-else style="cursor:pointer">
                        <img src="../../../../assets/images/collect-select.png" />
                    </a>

                </div>

            </div>
            <div class="jianjie">
                <div class="title">{{ detail.title }}</div>
                <div class="jianjie-content">{{ detail.introduction ? detail.introduction : '暂无' }}</div>
            </div>
        </div>
        <payment ref="payment"></payment>

    </div>
</template>
<script>
import payment from '../../../../components/payment.vue';
import axiosConfig from '../../../../config/config'; // axios请求配置
import pdf from '@/components/pdf/index.vue'
export default {
    inject: ['reload'],
    components: { payment, pdf },
    data() {
        return {
            id: null,
            detail: null,
            loading: false,
            collectData: {
                userId: this.$store.state.userId,
                reportId: '',
                type: 2,
                isCollect: 0
            },
            basUrl: axiosConfig.baseURL,
            userId: this.$store.state.userId
        }
    },
    created() {
        this.id = this.$route.query.id
        this.getDetail(this.$route.query.id);

    },
    methods: {
        getDetail(id) {
            this.loading = true
            this.collectData.reportId = id
            let data = {
                id: id,
                userId: this.$store.state.userId
            }
            this.apis.caseDetail(data).then(res => {
                this.loading = false
                this.detail = res.data
            })
        },
        // 试读
        toTrial(id) {
            this.$router.push({
                path: '/trial',
                query: {
                    id: id,
                    type: 2
                }
            })
        },
        // 收藏/取消收藏
        setCollect(e) {
            this.collectData.isCollect = e
            this.apis.setCollec(this.collectData).then(res => {
                if (res.code == 0) {
                    this.reload()
                }
            })
        },
        // 立即购买
        setPayment() {
            let data = {
                status: true,
                price: this.detail.webPrice,
                userId: this.$store.state.userId,
                reportId: this.detail.id,
                reportType: 2,
                description: this.detail.title
            }
            this.$refs.payment.setVisible(data)
        },
        // 阅读pdf
        readPdf(id) {
            this.$router.push({
                path: '/pdf',
                query: {
                    id: id,
                }
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/index/components/detail/work_results.vue